'use client';

import React, { useState, memo, useCallback } from "react";
import classNames from "classnames";
import ReactHtmlParser from "html-react-parser"; // Ensure this is installed

interface ReadMoreAreaProps {
  expandLabel: string;
  collapseLabel: string;
  lettersLimit: number;
  children: any;
}

const ReadMoreArea: React.FC<ReadMoreAreaProps> = ({
  expandLabel,
  collapseLabel,
  lettersLimit,
  children,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  const childrenText = typeof children === "string" ? children : "";
  const isOverMinLength = childrenText.length > lettersLimit;

  const shortedText = isOverMinLength
    ? `${childrenText.substring(0, lettersLimit)}...`
    : childrenText;

  if (!childrenText) return null;

  return (
    <div className="mt-5 md:mt-0">
      <span
        className={classNames("read-more-box", {
          "is-expanded": isExpanded,
        })}
      >
        {ReactHtmlParser(isExpanded ? childrenText : shortedText)}
      </span>

      {isOverMinLength && (
        <button
          onClick={toggleReadMore}
          className="underline hover:opacity-80 font-semibold duration-200 transition-all cursor-pointer"
        >
          {isExpanded ? collapseLabel : expandLabel}
        </button>
      )}
    </div>
  );
};

export default memo(ReadMoreArea);
